<div class="min-h-screen bg-white dark:bg-black rounded-lg p-4">
  <div class="mb-4">
    <p-breadcrumb
      [model]="displayUserBreadcrumbs()"
      styleClass="rounded-lg border border-gray-200 dark:border-gray-800"
    >
      <ng-template #separator>
        <i class="pi pi-chevron-right text-primary-400 text-sm mx-2"></i>
      </ng-template>
      <ng-template #item let-item>
        @if (item.routerLink && !item.disabled) {
          <a
            [routerLink]="item.routerLink"
            class="flex items-center text-primary-600 hover:text-primary-800 dark:hover:text-primary-500 dark:text-primary-300 transition-colors duration-200"
          >
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span>{{ item.label | translate }}</span>
          </a>
        } @else {
          <span class="flex items-center text-primary-600 dark:text-primary-300">
            @if (item.icon) {
              <i [class]="item.icon + ' mr-2'"></i>
            }
            <span class="font-medium">{{ item.label | translate }}</span>
          </span>
        }
      </ng-template>
    </p-breadcrumb>
  </div>

  <div class="users-content">
    <div class="users-toolbar grid grid-cols-1 md:grid-cols-2 md:gap-4 gap-3 mb-4">
      <div class="mb-6 flex items-center gap-4">
        <div class="flex size-16 items-center justify-center rounded-full bg-primary-100 shrink-0">
          <i class="pi pi-users text-primary-500 dark:text-primary-700 text-3xl!"></i>
        </div>
        <div class="flex min-w-0 flex-col justify-center">
          <h2 class="text-3xl font-bold text-gray-900 dark:text-white leading-tight">
            {{ 'usersModule.title' | translate }}
          </h2>
          <p class="mt-1 text-gray-600 dark:text-gray-300">
            {{ 'usersModule.subtitle' | translate }}
          </p>
        </div>
      </div>
    </div>

    <lib-user-table
      (clearFilters)="onTableClearFilters()"
      (createUserClick)="showCreateUserModal()"
      (deleteUser)="onDeleteUser($event)"
      (editUser)="onEditUser($event)"
      (pageChange)="onPageChange($event)"
      (searchTermChange)="onTableSearchChange($event)"
      (statusFilterChange)="onTableStatusChange($event)"
      (toggleStatus)="onToggleStatus($event)"
      [first]="first"
      [loading]="(loading$ | async) || false"
      [rows]="rows"
      [searchTerm]="searchTerm"
      [selectedStatus]="selectedStatus"
      [statusOptions]="statusOptions"
      [totalRecords]="totalRecords"
      [users]="(users$ | async) || []"
    ></lib-user-table>
  </div>

  <!-- Modal para crear usuario -->
  <p-dialog
    (onHide)="hideCreateUserModal()"
    [(visible)]="showCreateUserDialog"
    [closable]="false"
    [modal]="true"
    [resizable]="false"
    [style]="{ width: '500px' }"
    header="{{ 'usersModule.newUser' | translate }}"
  >
    <form (ngSubmit)="onCreateUser()" [formGroup]="userForm" class="min-h-[345px] space-y-6">
      <!-- Name -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="name">{{ 'usersModule.name' | translate }} *</label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-user"></i>
          </p-inputgroup-addon>
          <input
            [class.ng-invalid]="isFieldInvalid('name')"
            class="w-full"
            formControlName="name"
            id="name"
            pInputText
            type="text"
          />
        </p-inputgroup>
        @if (isFieldInvalid('name')) {
          <div class="text-red-500 text-xs mt-1">
            {{ getFieldError('name') }}
          </div>
        }
      </div>

      <!-- Email -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="email">Email *</label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-envelope"></i>
          </p-inputgroup-addon>

          <input
            [class.ng-invalid]="isFieldInvalid('email')"
            class="w-full"
            formControlName="email"
            id="email"
            pInputText
            type="email"
          />
        </p-inputgroup>
        @if (isFieldInvalid('email')) {
          <div class="text-red-500 text-xs mt-1">
            {{ getFieldError('email') }}
          </div>
        }
      </div>

      <!-- Password -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="password">{{ 'auth.password' | translate }} *</label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-lock"></i>
          </p-inputgroup-addon>

          <input
            #passwordInput
            [class.ng-invalid]="isFieldInvalid('password')"
            class="w-full"
            formControlName="password"
            id="password"
            pInputText
            type="password"
          />
          <p-inputgroup-addon>
            <button
              (click)="togglePasswordVisibility(passwordInput)"
              [attr.aria-label]="
                passwordInput.type === 'password'
                  ? ('auth.showPassword' | translate)
                  : ('auth.hidePassword' | translate)
              "
              class="border-none bg-transparent cursor-pointer p-0 m-0"
              type="button"
            >
              <i
                [class.pi-eye-slash]="passwordInput.type === 'text'"
                [class.pi-eye]="passwordInput.type === 'password'"
                class="pi"
              ></i>
            </button>
          </p-inputgroup-addon>
        </p-inputgroup>
      </div>

      @if (userForm.get('password')?.errors && userForm.get('password')?.value) {
        <div
          @fadeInOut
          class="transition ease-in-out delay-150 rounded-md p-4 bg-primary-100 text-primary-500 text-sm"
        >
          <ul class="list-disc list-inside">
            @if (userForm.get('password')?.errors?.['uppercase']) {
              <li>
                {{ 'usersModule.errors.password.uppercase' | translate }}
              </li>
            }
            @if (userForm.get('password')?.errors?.['lowercase']) {
              <li>
                {{ 'usersModule.errors.password.lowercase' | translate }}
              </li>
            }
            @if (userForm.get('password')?.errors?.['characters']) {
              <li>
                {{ 'usersModule.errors.password.characters' | translate }}
              </li>
            }
            @if (userForm.get('password')?.errors?.['special']) {
              <li>
                {{ 'usersModule.errors.password.special' | translate }}
              </li>
            }
          </ul>
        </div>
      }
    </form>

    <ng-template #footer>
      <div class="flex justify-end gap-2">
        <p-button
          (onClick)="hideCreateUserModal()"
          [disabled]="isSubmitting"
          [outlined]="true"
          label="{{ 'button.Cancel' | translate }}"
          severity="secondary"
        ></p-button>
        <p-button
          (onClick)="onCreateUser()"
          [disabled]="userForm.invalid"
          [loading]="isSubmitting"
          label="{{ 'button.create' | translate }}"
          severity="primary"
        ></p-button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Modal para editar usuario -->
  <p-dialog
    (onHide)="hideEditUserModal()"
    [(visible)]="showEditUserDialog"
    [breakpoints]="{ '390px': '350px' }"
    [closable]="true"
    [draggable]="false"
    [modal]="true"
    [resizable]="false"
    [style]="{ width: '500px', height: '600px' }"
    contentStyleClass="transition-all duration-300 ease-in-out"
    header="{{ 'usersModule.editUser' | translate }}"
  >
    <form
      (ngSubmit)="onUpdateUser()"
      [@smoothResize]
      [formGroup]="editUserForm"
      class="p-6 space-y-6"
    >
      <!-- Name -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="edit-name">
          {{ 'usersModule.name' | translate }} *
        </label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-user"></i>
          </p-inputgroup-addon>
          <input
            [class.ng-invalid]="isEditFieldInvalid('name')"
            class="w-full"
            formControlName="name"
            id="edit-name"
            pInputText
            type="text"
          />
        </p-inputgroup>
        @if (isEditFieldInvalid('name')) {
          <div class="text-red-500 text-xs mt-1">
            {{ getEditFieldError('name') }}
          </div>
        }
      </div>

      <!-- Email -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="edit-email">Email *</label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-envelope"></i>
          </p-inputgroup-addon>
          <input
            [class.ng-invalid]="isEditFieldInvalid('email')"
            class="w-full"
            formControlName="email"
            id="edit-email"
            pInputText
            type="email"
          />
        </p-inputgroup>
        @if (isEditFieldInvalid('email')) {
          <div class="text-red-500 text-xs mt-1">
            {{ getEditFieldError('email') }}
          </div>
        }
      </div>

      <!-- Roles -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="edit-role">
          {{ 'usersModule.role' | translate }} *
        </label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-shield"></i>
          </p-inputgroup-addon>
          <p-multiSelect
            [class.ng-invalid]="isEditFieldInvalid('roles')"
            [loading]="loadingRoles"
            [options]="roles"
            [placeholder]="'usersModule.selectRole' | translate"
            appendTo="body"
            class="w-full"
            display="chip"
            formControlName="roles"
            id="edit-role"
            optionLabel="label"
            optionValue="value"
          ></p-multiSelect>
        </p-inputgroup>
        @if (isEditFieldInvalid('roles')) {
          <div class="text-red-500 text-xs mt-1">
            {{ getEditFieldError('roles') }}
          </div>
        }
      </div>

      <!-- Password -->
      <div class="h-16">
        <label class="text-sm block mb-1" for="edit-password">
          {{ 'auth.password' | translate }}
        </label>
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-lock"></i>
          </p-inputgroup-addon>
          <input
            #passwordInputEdit
            [class.ng-invalid]="isEditFieldInvalid('password')"
            [placeholder]="'usersModule.leaveEmptyNoChange' | translate"
            class="w-full"
            formControlName="password"
            id="edit-password"
            pInputText
            type="password"
          />
          <p-inputgroup-addon>
            <button
              (click)="togglePasswordVisibility(passwordInputEdit)"
              [attr.aria-label]="
                passwordInputEdit.type === 'password'
                  ? ('auth.showPassword' | translate)
                  : ('auth.hidePassword' | translate)
              "
              class="border-none bg-transparent cursor-pointer p-0 m-0"
              type="button"
            >
              <i
                [class.pi-eye-slash]="passwordInputEdit.type === 'text'"
                [class.pi-eye]="passwordInputEdit.type === 'password'"
                class="pi"
              ></i>
            </button>
          </p-inputgroup-addon>
        </p-inputgroup>
      </div>

      @if (editUserForm.get('password')?.errors && editUserForm.get('password')?.value) {
        <div
          @fadeInOut
          class="transition ease-in-out delay-150 rounded-md p-4 bg-primary-100 text-primary-500 text-sm"
        >
          <ul class="list-disc list-inside">
            @if (editUserForm.get('password')?.errors?.['uppercase']) {
              <li>
                {{ 'usersModule.errors.password.uppercase' | translate }}
              </li>
            }
            @if (editUserForm.get('password')?.errors?.['lowercase']) {
              <li>
                {{ 'usersModule.errors.password.lowercase' | translate }}
              </li>
            }
            @if (editUserForm.get('password')?.errors?.['characters']) {
              <li>
                {{ 'usersModule.errors.password.characters' | translate }}
              </li>
            }
            @if (editUserForm.get('password')?.errors?.['special']) {
              <li>
                {{ 'usersModule.errors.password.special' | translate }}
              </li>
            }
          </ul>
        </div>
      }

      <!-- Estados -->
      <div class="grid grid-cols-1 gap-4">
        <div class="flex items-center">
          <p-checkbox binary="true" formControlName="is_active" id="edit-is-active"></p-checkbox>
          <label class="ml-2" for="edit-is-active">
            {{ 'usersModule.userActive' | translate }}
          </label>
        </div>

        <div class="flex items-center">
          <p-checkbox binary="true" formControlName="is_deleted" id="edit-is-deleted"></p-checkbox>
          <label class="ml-2" for="edit-is-deleted">
            {{ 'usersModule.userDeleted' | translate }}
          </label>
        </div>
      </div>
    </form>

    <ng-template #footer>
      <div class="flex justify-end gap-2">
        <p-button
          (onClick)="hideEditUserModal()"
          [disabled]="isEditingSubmitting"
          [label]="'common.cancel' | translate"
          [outlined]="true"
          severity="primary"
          variant="outlined"
        />
        <p-button
          (onClick)="onUpdateUser()"
          [disabled]="editUserForm.invalid"
          [label]="'usersModule.updateUser' | translate"
          [loading]="isEditingSubmitting"
          severity="primary"
        />
      </div>
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="showDeleteConfirmDialog"
    [closable]="false"
    [modal]="true"
    [style]="{ width: '350px' }"
    header="{{ 'usersModule.DeleteTitle' | translate }}"
  >
    <div class="flex flex-col gap-4">
      <p>
        {{ 'usersModule.DeleteMessage' | translate: { name: userToDelete?.name } }}
      </p>

      <div class="flex justify-end gap-2 mt-4">
        <p-button
          (onClick)="showDeleteConfirmDialog = false"
          label="{{ 'button.Cancel' | translate }}"
          severity="primary"
          variant="outlined"
        />
        <p-button
          (onClick)="onConfirmDelete()"
          label="{{ 'button.Confirm' | translate }}"
          severity="danger"
        />
      </div>
    </div>
  </p-dialog>
</div>
